import React from 'react';
import { Link } from 'react-router-dom';
import { SHOP_CREATE_SOT_VALUES, shopCreateSotHref } from './createShopJob';
import { shopJobsSotExitHref } from './jobsSurface';

const CREATE_SOT_LABELS = {
    error: 'CREATE · ERROR',
    offline: 'CREATE · OFFLINE',
    denied: 'CREATE · DENIED',
    pending: 'CREATE · PENDING',
};

const CreateSotSwitcher = ({ active }) => (
    <nav
        className="jobs-sot-switcher"
        data-testid="create-sot-switcher"
        aria-label="Shop create SoT"
    >
        {SHOP_CREATE_SOT_VALUES.map((surface) => (
            <Link
                key={surface}
                className={`jobs-sot-link${active === surface ? ' is-active' : ''}`}
                to={shopCreateSotHref(surface)}
            >
                {CREATE_SOT_LABELS[surface]}
            </Link>
        ))}
        <Link className="jobs-sot-link" to={shopJobsSotExitHref()}>
            Exit SoT
        </Link>
    </nav>
);

export default CreateSotSwitcher;
